/***
 *
 *   ONBOARDING LAYOUT
 *   Focused layout for a user to complete the onboarding flow.
 *
 *   DOCS
 *   https://docs.useMapMetrics Atlas.app/MapMetrics Atlas-web/components/layout
 *
 *   PROPS
 *   children: will be passed from router > view > here (component(s), required)
 *
 **********/

import { useEffect } from "react";
import { Animate } from "components/lib";

export function OnboardingLayout({ children }) {
  // set the background color
  useEffect(() => {
    document.body.style.backgroundColor = "#0f172a";
    return () => (document.body.style.backgroundColor = "");
  }, []);

  return (
    <main className="flex w-full min-h-screen items-center justify-center overflow-auto py-8 relative">
      {/* Portal background with glassmorphism */}
      <div className="fixed inset-0 portal-gradient portal-dots-pattern">
        <div className="absolute inset-0 portal-gradient-overlay"></div>
        <div className="absolute inset-0 portal-mesh-pattern opacity-30"></div>
      </div>
      <div className="relative z-10">
        <Animate>{children}</Animate>
      </div>
    </main>
  );
}
